// What the shared DOM components (@todo/web-ui) show on dubai-todo.com: the
// logo, the lists and the design's photos. @todo/web-ui reads it as the
// `@site-ui` alias (tsconfig.json), as @todo/core reads src/site.ts as `@site`.

import type { SiteUi } from '@todo/web-ui/lib/site-ui';

import { BrandLockup } from '@/components/brand-lockup';
import { CATEGORY_STRIP, COLLECTIONS, HUB_GUIDES } from '@/lib/collections';
import { FOOTER_IMAGE, HERO_IMAGE, HERO_SIZE, HERO_SRCSET, MOOD_TILES, SAMPLE_CARDS } from '@/lib/placeholders';

export const SITE_UI = {
  BrandLockup,
  // Header nav, in design order. "Guides" leads to the Sanity articles,
  // Events to Platinumlist's shows (since 2026-10-29).
  nav: [
    { key: 'nav.tours', path: 'tours' },
    { key: 'nav.boats', path: 'boats' },
    { key: 'nav.desert', path: 'desert-safari' },
    { key: 'nav.attractions', path: 'attractions' },
    { key: 'nav.dayTrips', path: 'day-trips' },
    { key: 'nav.events', path: 'events' },
    { key: 'nav.guides', path: 'guides' },
  ],
  footer: {
    thingsToDo: [
      { key: 'footer.tours', short: 'nav.tours', path: 'tours' },
      { key: 'collections.desert-safari.title', path: 'desert-safari' },
      { key: 'nav.boats', path: 'boats' },
      { key: 'collections.day-trips.title', path: 'day-trips' },
      { key: 'collections.new-years-eve.title', path: 'new-years-eve' },
    ],
    areas: [
      { key: 'collections.downtown-dubai.title', short: 'collections.downtown-dubai.short', path: 'downtown-dubai' },
      { key: 'collections.dubai-marina.title', path: 'dubai-marina' },
      { key: 'collections.palm-jumeirah.title', path: 'palm-jumeirah' },
      { key: 'collections.old-dubai.title', path: 'old-dubai' },
      // "Where to stay in Dubai", area by area.
      { key: 'nav.hotels', path: 'hotels' },
    ],
  },
  // The sister sites. A locale one doesn't have (DE) links to its /en.
  sisterSites: [
    { name: 'Riviera To-Do', url: 'https://riviera-todo.com', locales: ['en', 'fr', 'ru'] },
    { name: 'Miami To-Do', url: 'https://miami-todo.com', locales: ['en', 'es', 'ru'] },
  ],
  collections: COLLECTIONS,
  hubGuides: HUB_GUIDES,
  categoryStrip: CATEGORY_STRIP,
  hero: { image: HERO_IMAGE, ...HERO_SIZE, srcSet: HERO_SRCSET },
  footerImage: FOOTER_IMAGE,
  moodTiles: MOOD_TILES,
  sampleCards: SAMPLE_CARDS,
} as const satisfies SiteUi;
